import React, { useState, useEffect } from 'react';
import { Table, Input, Tabs, Button, Modal, Form, Select } from 'antd';
import { EditOutlined, DeleteOutlined, SaveOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { productsService } from "../../services/ProductsService";
import Menu from '../../components/Menu/Menu';
import './CreateList.scss';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MobileBottomMenu from '../../components/MobileBottomMenu/MobileBottomMenu';
import MobileMenu from "../../components/Menu/MobileMenu";
import Header from '../../components/Header/Header';
import { listService } from "../../services/ListService";

const { Search } = Input;
const { TabPane } = Tabs;
const { Option } = Select;

const OriginalCreateList = () => {
    const navigate = useNavigate();
    const [isEditing, setIsEditing] = useState(false);
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
    const [activeTab, setActiveTab] = useState("creeaza");
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [form] = Form.useForm();
    const [listExists, setListExists] = useState(false);
    const [listId, setListId] = useState(null);
    const [lists, setLists] = useState([]);
    const [currentList, setCurrentList] = useState(null);
    const [index, setIndex] = useState(-1);




    useEffect(() => {
        handleSearch('');

        listService.getLists()
            .then(res => {
                if (res.data) {
                    setLists(res.data);
                }
            })
            .catch(err => {
                console.error("Eroare la încărcarea listelor:", err);
            });
    }, []);
    const handleSearch = (value) => {
        setSearchQuery(value);
        if (value.length > 0) {
            productsService.searchProduct(value, 1)
                .then(res => {
                    if (res.data?.products) {
                        setSearchResults(res.data.products);
                    } else {
                        setSearchResults([]);
                    }
                })
                .catch(err => {
                    console.error("Eroare la căutare:", err);
                    setSearchResults([]);
                });
        } else {
            setSearchResults([]);
        }
    };

    const handleTabChange = (key) => {
        setActiveTab(key);
    };

    const handleEdit = (record) => {
        console.log(record)
        setSelectedProduct({
            id: record.product_id,
            name: record.name,
        });
        setIsEditing(true);
        setIsModalVisible(true);
        form.setFieldsValue({
            quantity: record.quantity,
            unit_measurement: record.unit_measurement,
            supplementary_info: record.instructions || ''
        });
    };
    const handleDeleteProduct = product => {
    console.log(product)
    
        listService.deleteProduct(listId, product.product_id)
            .then(() => {
                toast.success('Stergere reusita')
                setProducts(prevProducts => prevProducts.filter(product => product.id !== product.product_id));
                setIsDeleteModalVisible(false)
                           })
            .catch(error => {
                console.error('Eroare');
                setIsDeleteModalVisible(false);
            });
    };
    const openModal = (product) => {
        setIsEditing(false);
        setSelectedProduct(product);
        setIsModalVisible(true);
        form.setFieldsValue({
            name: product.name,
            quantity: '',
            unit_measurement: '',
            supplementary_info: ''
        });
    };

    const showDeleteModal = (product) => {
        setSelectedProduct(product);
   
        setIsDeleteModalVisible(true);
    };

    const handleCancelDelete = () => {
        setIsDeleteModalVisible(false);
    };
    const handleSubmitProduct = () => {
        form.validateFields().then(values => {
            if (!selectedProduct) {
                console.error("No product selected");
                return;
            }

            const options = {
                product_id: selectedProduct.id,
                quantity: values.quantity,
                unit_measurement: values.unit_measurement,
                supplementary_info: values.supplementary_info || '',
            };

            if (listId) {
                options.list_id = listId;
            } else {
                options.list_description = values.list_description || '';
            }

            setLoading(true);
            console.log('editare')
            console.log(listId,options)
            const request = isEditing
                ? listService.editProduct(listId, options)
                : listService.addProductToList(options);

            request.then(response => {
                console.log(response);
                const item = response.data.item;

                if (!item) {
                    toast.error("Eroare: Răspuns invalid de la server.");
                    return;
                }

                const newProduct = {
                    key: item.id,
                    name: selectedProduct.name,
                    quantity: item.quantity,
                    instructions: item.supplementary_info || '',
                    status: 'Necesar',
                    unit_measurement: item.unit_measurement,
                    product_id: item.product_id,
                };

                console.log('aaa');
                console.log(newProduct);

                setProducts(prev => {
                    if (isEditing) {
                        return prev.map(p => p.product_id === selectedProduct.id ? newProduct : p);
                    } else {
                        return [...prev, newProduct];
                    }
                });

                if (!listId && item.necessity_list_id) {
                    setListId(item.necessity_list_id);
                    setListExists(true);
                }

                toast.success(isEditing ? "Produs actualizat!" : "Produs adăugat!");

                setIsModalVisible(false);
                setIsEditing(false);
                setSelectedProduct(null);
                form.resetFields();
                setSearchQuery('');
                setSearchResults([]);
                setActiveTab("creeaza");

            }).catch(err => {
                console.error('Eroare la salvare:', err);
                toast.error("A apărut o eroare.");
            }).finally(() => {
                setLoading(false);
            });
        });
    };
    const columns = [
        {
            title: 'Nume produs',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Cantitate',
            dataIndex: 'quantity',
            key: 'quantity',
            render: (_, record) => `${record.quantity} ${record.unit_measurement || ''}`,
        },
        {
            title: 'Indicații',
            dataIndex: 'instructions',
            key: 'instructions',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
        },
        {
            title: 'Editează',
            key: 'edit',
            render: (_, record) => (
                <Button
                    type="link"
                    icon={<EditOutlined />}
                    onClick={() => handleEdit(record)}
                />
            ),
        },
        {
            title: 'Șterge',
            key: 'delete',
            render: (_, record) => (
                <Button
                    type="link"
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => {
                        setSelectedProduct(record);
                        showDeleteModal(record);
                    }}
                />
            ),
        },
    ];
    const listColumns = [
        {
            title: 'Număr listă',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'Nume',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Data creare',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (value) => new Date(value).toLocaleDateString('ro-RO'),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
        },
        {
            title: 'Programat pe',
            dataIndex: 'scheduled_for',
            key: 'scheduled_for',
            render: (value) => value ? new Date(value).toLocaleDateString('ro-RO') : '—',
        },
        {
            title: 'Acțiuni',
            key: 'actions',
            render: (_, record) => (
                <Select
                    placeholder="Opțiuni listă"
                    onChange={(value) => handleListAction(value, record)}
                    style={{ width: 180 }}
                >
                    <Option value="view">👁️ Vezi/editează lista</Option>
                    <Option value="schedule">📅 Programează bid</Option>
                    <Option value="send">📤 Trimite lista</Option>
                    <Option value="delete" style={{ color: 'red' }}>🗑️ Șterge lista</Option>
                </Select>
            )
        }
    ];
    const handleListAction = (action, record) => {
        console.log(record);

        switch (action) {
            case 'view':
                listService.getSpecificList(record.id)
                    .then(res => {
                        const data = res.data;

                        const loadedProducts = data.necessity_list_items.map(item => ({
                            key: item.id,
                            name: item.product?.name || '',
                            quantity: item.quantity,
                            instructions: item.supplementary_info || '',
                            status: 'Necesar',
                            unit_measurement: item.unit_measurement || '',
                            product_id: item.product_id,
                        }));

                        setProducts(loadedProducts);
                        setListId(data.id);
                        setListExists(true);
                        setActiveTab("creeaza");
                        setCurrentList(data);
                    })
                    .catch(err => {
                        console.error("Eroare la încărcarea listei:", err);
                    });
                break;
            case 'schedule':
                console.log("Programare bid pentru lista:", record.id);
                break;
            case 'send':
                console.log("Trimite lista:", record.id);
                break;
            case 'delete':
                Modal.confirm({
                    title: 'Ești sigur că vrei să ștergi această listă?',
                    content: `Lista: ${record.name}`,
                    okText: 'Da, șterge',
                    okType: 'danger',
                    cancelText: 'Anulează',
                    onOk: () => {
                        listService.deleteList(record.id)
                            .then(() => {
                                setLists(prev => prev.filter(item => item.id !== record.id));
                            })
                            .catch(err => {
                                console.error("Eroare la ștergerea listei:", err);
                            });
                    }
                });
                break;
            default:
                break;
        }
    };
    const handleSaveList = () => {
        if (!listId || products.length === 0) {
            toast.error("Lista este goală sau nu a fost creată încă.");
            return;
        }
    
        const updatedProducts = products.map(product => ({
            product_id: product.product_id,
            quantity: product.quantity,
            unit_measurement: product.unit_measurement,
            supplementary_info: product.instructions || ''
        }));
    
        const payload = {
            list_id: listId,
            products: updatedProducts
        };
    
        setLoading(true);
    
        listService.updateList(payload)
            .then(() => {
                toast.success("Lista a fost salvată cu succes!");
            })
            .catch((error) => {
                console.error("Eroare la salvarea listei:", error);
                toast.error("Eroare la salvarea listei.");
            })
            .finally(() => {
                setLoading(false);
            });
    };
    return (
        <div className='standard products list'>
            <Header />
            <div className='standard__mobile-header'>
                <img src='/images/logo.png' alt='logo' className='standard__only-mobile standard__mobile-logo' />
                <MobileMenu />
            </div>

            <div className='standard__container list'>
                <Menu />
                <div className='standard__wrapper'>
                    <div style={{ padding: 24, minHeight: 280 }}>
                        <h2 className='standard__page-title'>Creează lista de necesar</h2>
                        <h4 className='standard__page-info'>
                            Editează o listă importată sau adaugă manual produse în lista de necesar, căutându-le și completând formularul.
                        </h4>

                        <div className='list__search-box'>
                            <Search
                                className="list__search-input"
                                placeholder="Caută produs..."
                                onChange={(e) => handleSearch(e.target.value)}
                                value={searchQuery}
                                enterButton
                                allowClear
                                style={{ width: 300 }}
                            />
                            {searchResults.length > 0 && (
                                <ul className="list__search-dropdown">
                                    {searchResults.map((product) => {
                                        const regex = new RegExp(`(${searchQuery})`, "gi");
                                        const highlightedName = product.name.replace(regex, (match) => `<span class="search__highlight">${match}</span>`);

                                        return (
                                            <div className='search__result' key={product.id}>
                                                <img src='/images/search.png' alt='search' />
                                                <li>
                                                    <a
                                                        className='standard__link'
                                                        href="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            openModal(product);
                                                        }}
                                                        dangerouslySetInnerHTML={{ __html: highlightedName }}
                                                    />
                                                </li>
                                            </div>
                                        );
                                    })}
                                </ul>
                            )}
                        </div>

                        {/* Tabs and metadata header */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                            <Tabs activeKey={activeTab} onChange={handleTabChange}>
                                <TabPane tab="Creează lista" key="creeaza" />
                                <TabPane tab="Gata de trimis" key="gata" />
                                <TabPane tab="Lista în ofertare" key="in_ofertare" />
                                <TabPane tab="Lista ofertate" key="ofertate" />
                            </Tabs>

                            {currentList && currentList.created_at && (
                                <div style={{ textAlign: 'right', marginLeft: 'auto' }}>
                                    <div><strong>Listă #{currentList.id}</strong></div>
                                    <div>Creată pe: {new Date(currentList.created_at).toLocaleDateString('ro-RO')}</div>
                                </div>
                            )}
                        </div>

                        {/* Tab Content */}
                        {activeTab === 'creeaza' && (
                            <div>
                                <Table
                                    dataSource={products}
                                    columns={columns}
                                    pagination={false}
                                    rowKey="key"
                                    loading={loading}
                                />
                                <Button
                                    type="primary"
                                    className='list__save-button'
                                    icon={<SaveOutlined />}
                                    onClick={handleSaveList}
                                    disabled={products.length === 0}
                                >
                                    Salvează lista
                                </Button>
                            </div>

                        )}

                        {activeTab === 'gata' && (
                            <Table
                                dataSource={lists}
                                columns={listColumns}
                                rowKey="id"
                                pagination={false}
                            />
                        )}

                        {activeTab === 'in_ofertare' && (
                            <p>Produse în curs de ofertare.</p>
                        )}

                        {activeTab === 'ofertate' && (
                            <p>Produse deja ofertate.</p>
                        )}
                    </div>
                </div>
            </div>

            <MobileBottomMenu />

            <Modal
                title={`Doriți să adăugați „${selectedProduct?.name}” în lista de necesar?`}
                open={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                onOk={handleSubmitProduct}
                okText={isEditing ? 'Editează' : 'Adaugă in lista'}
                cancelText="Anulează"
            >
                <Form form={form} layout="vertical">
                    <Form.Item name="quantity" label="Cantitate dorită" rules={[{ required: true }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item name="unit_measurement" label="Unitate de măsură" rules={[{ required: true }]}>
                        <Select placeholder="Selectează">
                            <Option value="bucăți">bucăți</Option>
                            <Option value="litri">litri</Option>
                            <Option value="kilograme">kilograme</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item name="supplementary_info" label="Informații suplimentare (opțional)">
                        <Input.TextArea />
                    </Form.Item>
                </Form>
            </Modal>
            <Modal
                title="Confirmă ștergere"
                visible={isDeleteModalVisible}
                onOk={() => handleDeleteProduct(selectedProduct)}
                onCancel={handleCancelDelete}
                okText="Șterge"
                cancelText="Cancel"
            >
                <p>Sunteți sigur că doriți să ștergeți acest produs?</p>
            </Modal>
        </div>
    );
};

export default OriginalCreateList;